import { render } from "./LogView.vue?vue&type=template&id=0a84f4f5"
import script from "./LogView.vue?vue&type=script&lang=js"
export * from "./LogView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__